import { render, staticRenderFns } from "./list-exchange-shipping-btn .vue?vue&type=template&id=659a83bb&"
import script from "./list-exchange-shipping-btn .vue?vue&type=script&lang=js&"
export * from "./list-exchange-shipping-btn .vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports